Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS,
    fontRegular = _STYLES$useStyles.fontRegular,
    bp = _STYLES$useStyles.bp;
  var globalMessage = Object.assign({}, fontRegular, {
    marginBottom: spacing.xl,
    backgroundColor: COLORS.snuff,
    color: COLORS.aubergine,
    borderRadius: (0, _styles.getREM)(1),
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    padding: spacing.normal,
    overflow: 'hidden'
  });
  if (bp.mobile_xs) {
    globalMessage.padding = spacing.xs;
    globalMessage.borderRadius = (0, _styles.getREM)(0.5);
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    globalMessage.padding = spacing.l;
    globalMessage.fontSize = _styles.STYLES.fontSize.normal;
    globalMessage.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var styles = _reactNative.StyleSheet.create({
    globalMessage: globalMessage
  });
  return {
    styles: styles
  };
};